import React, { PureComponent } from 'react'
import { parseHtmlForReact } from './../../helpers'

class PriorityAnswer extends PureComponent {
    onClick = () => {
        const { optionId, handleClick } = this.props

        if (handleClick && optionId) {
            handleClick(optionId)
        }
    }
    render() {
        const { question, store, priority, optionId } = this.props
        const option = optionId ? question.optionSet.options.find((o) => o.id === optionId) : null
        const psClass = optionId ? 'question__priority__answer answered radius' : 'question__priority__answer radius'
        return (
            <div onClick={this.onClick} className={psClass}>{priority}. {optionId ? parseHtmlForReact(store.getOptionTitle(option, question)) : ''}</div>
        )
    }
}

export default PriorityAnswer
